import type { AutomationTemplate } from '../templates.types';
import { StatusFilter, type TemplateListStatus } from './types';

/**
 * Draft is keyed off the RAW filter being an empty array — never off a resolved-count of 0, so a
 * null (all-tenants) template on a platform with zero businesses is not misclassified as Draft.
 */
export function isDraftFilter(targetedTenantsFilter: string[] | null | undefined): boolean {
  return Array.isArray(targetedTenantsFilter) && targetedTenantsFilter.length === 0;
}

export function deriveTemplateStatus(template: AutomationTemplate): TemplateListStatus {
  if (isDraftFilter(template.targeted_tenants_filter)) {
    return StatusFilter.Draft;
  }
  return (template.activeBusinessIds?.length ?? 0) > 0 ? StatusFilter.Active : StatusFilter.Available;
}

/**
 * Business IDs a template is synced/available to: null/undefined = all current tenants, [] = none,
 * otherwise the filter intersected with the current roster (drops tenants that no longer exist).
 */
export function resolveSyncedBusinessIds(
  template: AutomationTemplate,
  rosterBusinessIds: string[],
): string[] {
  const filter = template.targeted_tenants_filter;
  if (filter === null || filter === undefined) {
    return rosterBusinessIds;
  }
  if (filter.length === 0) {
    return [];
  }
  const rosterSet = new Set(rosterBusinessIds);
  return filter.filter(id => rosterSet.has(id));
}

/** Business IDs with the template enabled, intersected with the current roster. */
export function resolveActiveBusinessIds(
  template: AutomationTemplate,
  rosterBusinessIds: string[],
): string[] {
  const rosterSet = new Set(rosterBusinessIds);
  return (template.activeBusinessIds ?? []).filter(id => rosterSet.has(id));
}
